import { GetOperatingManagersQuery, GetOperatingManagersQueryVariables } from "generated/graphql";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { useRouter } from "Hooks/useRouter";
import { goToManagersPage, queryParamsToProps } from "./queryParams";

export const ROWS_PER_PAGE = 10;

export const useOperatingManagersHook = () => {
  const { history, location } = useRouter();
  const { page } = queryParamsToProps(location.search);

  const { data, loading, error } = useQuery<
    GetOperatingManagersQuery,
    GetOperatingManagersQueryVariables
  >(queries.GET_OPERATING_MANAGERS, {
    variables: {
      page,
      perPage: ROWS_PER_PAGE,
    },
    fetchPolicy: "cache-and-network"
  });

  const onChangePage = (
    evt: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => goToManagersPage(history, { page: newPage });

  return {
    operatingManagers: data?.employer.currentProvider.employerRewardBudgets,
    rowsPerPage: ROWS_PER_PAGE,
    loading,
    error,
    onChangePage,
    page,
  };
};
